import React from 'react';
import { ChevronRight } from 'lucide-react';
export function WeddingReceptionSection() {
  return <section className="bg-neutral-100 py-20 px-8" data-id="element-438">
      <div className="max-w-7xl mx-auto" data-id="element-439">
        {/* Section Header */}
        <div className="text-center mb-16" data-id="element-440">
          <div className="w-16 h-0.5 bg-brand-pink mx-auto mb-6" data-id="element-441" />
          <div className="text-brand-pink text-xs tracking-[0.4em] font-light uppercase mb-4" data-id="element-442">
            Celebrate in Style
          </div>
          <h2 className="font-heading text-5xl font-normal text-neutral-900 mb-6" data-id="element-443">
            Reception
          </h2>
          <p className="text-lg text-neutral-600 max-w-3xl mx-auto leading-relaxed" data-id="element-444">
            Celebrate your dream wedding reception at Peterson House, one of the
            premier Hunter Valley wedding venues.
          </p>
        </div>

        {/* Glass Marquee - Image Left on Desktop, Below Content on Mobile */}
        <div className="mb-16" data-id="element-445">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center" data-id="element-446">
            {/* Image */}
            <div className="relative aspect-[4/3] overflow-hidden rounded border-8 border-gray-100 shadow-xl bg-gray-300 order-2 lg:order-1" data-id="element-447">
              <img src="https://crudemomultisite.kinsta.cloud/wine-theme-1/wp-content/uploads/sites/2/2025/11/MARQUEE-RECEPTION-IJ-533-Luminous-photography.jpg" alt="Glass Marquee reception space" className="w-full h-full object-cover" data-id="element-448" />
            </div>

            {/* Content */}
            <div className="space-y-6 order-1 lg:order-2" data-id="element-449">
              <div className="space-y-3" data-id="element-450">
                <div className="w-12 h-0.5 bg-brand-pink" data-id="element-451"></div>
                <h3 className="text-4xl font-serif text-gray-900" data-id="element-452">
                  Glass Marquee
                </h3>
              </div>
              <div className="space-y-4" data-id="element-453">
                <p className="text-gray-600 text-lg leading-relaxed" data-id="element-454">
                  Our permanent Glass Marquee offers a breathtaking reception
                  space, complete with fairy lights, elegant draping, and
                  stunning chandeliers. Our floor to ceiling glass doors open to
                  sweeping vineyard views, creating the perfect Hunter Valley
                  backdrop for your special day.
                </p>
              </div>
            </div>
          </div>
        </div>

        {/* Chapel Reception - Content Left, Image Right */}
        <div data-id="element-455">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center" data-id="element-456">
            {/* Content */}
            <div className="space-y-6 order-1 lg:order-1" data-id="element-457">
              <div className="space-y-3" data-id="element-458">
                <div className="w-12 h-0.5 bg-brand-pink" data-id="element-459"></div>
                <h3 className="text-4xl font-serif text-gray-900" data-id="element-460">
                  The Chapel
                </h3>
              </div>
              <div className="space-y-4" data-id="element-461">
                <p className="text-gray-600 text-lg leading-relaxed" data-id="element-462">
                  For something truly unique, transform our charming Chapel into
                  your reception venue. This intimate and romantic setting
                  delivers an unforgettable dining experience and a beautifully
                  exclusive atmosphere—ideal for couples seeking a distinctive
                  Hunter Valley wedding destination.
                </p>
              </div>
            </div>

            {/* Image */}
            <div className="relative aspect-[4/3] overflow-hidden rounded border-8 border-gray-100 shadow-xl bg-gray-300 order-2 lg:order-2" data-id="element-463">
              <img src="https://crudemomultisite.kinsta.cloud/wine-theme-1/wp-content/uploads/sites/2/2025/11/CHAPEL-RECEPTION-GIORGIA-SAM-1109.jpg" alt="Chapel reception space" className="w-full h-full object-cover" data-id="element-464" />
            </div>
          </div>
        </div>
      </div>
    </section>;
}